
  export default {
    props: {
      product: { type: String, required: true }
    },
    computed: {
      content () {
        return Object.values(this.$t(this.product));
      }
    }
  };
